import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const Requests = () =>
  import("@/views/manage/Requests.vue").then((m) => m.default);
const SuggestedResources = () =>
  import("@/views/manage/requestDetails/SuggestedResources.vue").then(
    (m) => m.default
  );
const Details = () =>
  import("@/views/manage/requestDetails/Details.vue").then((m) => m.default);
const Uploads = () =>
  import("@/views/manage/requestDetails/Uploads.vue").then((m) => m.default);
const Messages = () =>
  import("@/views/manage/requestDetails/Messages.vue").then((m) => m.default);
const Request = () =>
  import("@/views/manage/Request.vue").then((m) => m.default);

const getRequestRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/requests",
    component: RouteWrapper,
    meta: {
      title: "Requests",
      breadcrumb: {
        title: BreadcrumbsTitles.REQUESTS,
        icon: NavigationIcons.REQUESTS,
        routeName: RouteNames.MANAGE_REQUESTS,
        prefix: RouteSectionsPrefixes.REQUESTS,
        copyLink: true,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.MANAGE_REQUESTS,
        component: Requests,
        meta: {
          title: "Requests",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getRequestPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "resources",
    name: RouteNames.CUSTOM_REQUESTS_RESOURCES_SUGGESTED,
    component: SuggestedResources,
    meta: {
      title: "Suggested Resources",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "details",
    name: RouteNames.CUSTOM_REQUEST_DETAILS,
    component: Details,
    meta: {
      title: "Request Details",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "uploads",
    name: RouteNames.REQUEST_UPLOADS,
    component: Uploads,
    meta: {
      title: "Request Uploads",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "conversation",
    name: RouteNames.REQUEST_CONVERSATIONS,
    component: Messages,
    meta: {
      title: "Request Conversations",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getRequestPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: ":id",
    component: Request,
    props: true,
    meta: {
      title: "Request",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.REQUEST_DETAILS,
        isStyled: true,
      },
    },
  },
]);

export {
  getRequestRoutes,
  getRequestPrivatePageTabsRoutes,
  getRequestPrivatePageRoutes,
};
